// extracted by mini-css-extract-plugin
export var arrow = "_cb-1";
export var content = "_cb-0";
export var highlighted = "_cb-2";